<template>
  <v-row justify="center" :style="{ maxHeight: '130px' }" id="sgtm-easypak-sample-request-submitted">
    <CtaBtn @click="refreshPage">Request Another Sample</CtaBtn>
    <CtaBtn href="/product-search">View Products</CtaBtn>
  </v-row>
</template>

<script>
import CtaBtn from "@/components/CtaBtn.vue";

export default {
  name: "ThankYou",

  components: { CtaBtn },

  methods: {
    refreshPage() {
      window.location.reload();
    }
  }
};
</script>
